import { VariantSelectionContext } from '@/components/mini-quiz/mini-quiz-basic/variantsHandler';
import { generateRandomNumber } from '@/utils';

const CartHandlers = {
  bundle: (regimenObject, context) => {
    const {
      optionPlanSelected,
      deliveryTimeSelected,
      addToCart,
      colorSelected,
      redirectToCheckout,
      quantity
    } = getParametersFromContext(context);

    const retail_profile_id = `retail_bundle_${generateRandomNumber(5)}`;

    const productsToAdd = context.data.products.value.reduce((acc, product) => {
      const productToAdd = {
        id: product.variants[0].id,
        quantity: product.quantity,
        properties: {
          ...regimenObject,
          __product_handle: product.handle,
          __bundle_item: 'true',
          __bundle_title: context.collectionTitle,
          __product_type: product.productType,
          ...(product.is_retail === 'true' && {
            __is_retail: true,
            __profile_id: !regimenObject.__profile_id
              ? retail_profile_id
              : regimenObject.__profile_id
          })
        }
      };

      if (product.variants.length > 1) {
        const colorVariant = product.variants.find((variant) =>
          variant.title.includes(colorSelected)
        );
        productToAdd.id = colorVariant?.id ?? product.variants[0].id;
      }

      if (optionPlanSelected.value === 'subscribe') {
        const sellingPlanArrayIndex = Number(deliveryTimeSelected.value);
        const sellingPlan =
          product.selling_plan_groups[0].selling_plans[
            sellingPlanArrayIndex + 1
          ];
        productToAdd.selling_plan = sellingPlan.id;
      }

      if (context.productsColorBundle.length > 0) {
        const productColor = context.productsColorBundle.find(
          (x) => x.product_title === product.title
        )?.color;
        if (product.variants.length > 1 && productColor) {
          const colorVariant = product.variants.find((variant) =>
            variant.title.toLowerCase().includes(productColor.toLowerCase())
          );
          productToAdd.id = colorVariant?.id ?? product.variants[0].id;
        }
      }
      acc.push(productToAdd);
      return acc;
    }, []);

    if (!redirectToCheckout) {
      context.updateCtaText();
    }

    addToCart(productsToAdd);
  },
  standard: (regimenObject, context) => {
    const {
      variantId,
      optionPlanSelected,
      deliveryTimeSelected,
      addToCart,
      redirectToCheckout,
      quantity
    } = getParametersFromContext(context);

    const productToAdd = {
      id: variantId,
      quantity,
      properties: {
        ...regimenObject,
        __product_type: context.data.products.value[0].productType
      }
    };

    if (optionPlanSelected.value === 'subscribe') {
      const sellingPlanArrayIndex = Number(deliveryTimeSelected.value);
      const sellingPlan =
        context.data.products.value[0].selling_plan_groups[0].selling_plans[
          sellingPlanArrayIndex + 1
        ];
      productToAdd.selling_plan = sellingPlan.id;
    }

    if (!redirectToCheckout) {
      context.updateCtaText();
    }

    addToCart([productToAdd]);
  }
};

function getParametersFromContext(context) {
  const planSelector = context.shadowRoot.querySelector('plan-selector');
  const optionPlanSelected = planSelector.selectedOption;
  const deliveryTimeSelected = planSelector.selectedSellingPlan;
  const colorSelected =
    context.shadowRoot.querySelector('color-selection')?.selectedColor;
  const variantContext = new VariantSelectionContext();
  const variantId = variantContext.selectVariant(
    context.data.products.value[0],
    {
      productsColorBundle: context.productsColorBundle,
      colorSelected
    }
  );

  return {
    planSelector,
    optionPlanSelected,
    deliveryTimeSelected,
    colorSelected,
    variantId,
    redirectToCheckout: context.redirectToCheckout,
    addToCart: context.addToCart.bind(context),
    quantity: context.quantity
  };
}
export default CartHandlers;
export { getParametersFromContext };
